'use strict';
module.exports = require('./InputMask.vue');